export default [
  {
    title: 'گزارش‌ها',
    icon: 'bx bx-line-chart',
    children: [
      {
        title: 'فروش',
        route: { name: 'report-sales' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'محصولات',
        route: { name: 'report-products' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'مشتریان',
        route: { name: 'report-customers' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'سبد رهاشده',
        route: { name: 'report-abandoned' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'کدهای تخفیف',
        route: { name: 'report-coupons' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'خدمات',
        route: { name: 'report-duty' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'سرنخ‌ها',
        route: { name: 'report-leads' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'ترافیک',
        route: { name: 'report-traffic' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'محتوا',
        route: { name: 'report-content' },
        resource: 'ReportManager',
        action: 'show',
      },
      {
        title: 'سلامت سیستم',
        route: { name: 'report-operations' },
        resource: 'ReportManager',
        action: 'show',
      },
    ],
  },
]
